<div class="title">Which AIS product would you like to request?</div>
<div class="ais-product-options">
  <mat-nav-list>
    @for (product of products; track product) {
      <a
        style="padding: 0"
        [disabled]="product.path.toLowerCase() === 'not-sure'"
        class="list-item"
        [class]="product.path.toLowerCase()"
        mat-list-item
        [routerLink]="product.path.toLowerCase() !== 'not-sure' ? ['../', product.path] : null">
        <div class="container">
          <div class="top">
            <mat-icon [class]="product.path.toLowerCase()">
              @if (![productEnum.AIC, productEnum.AMDT].includes(product.path)) {
                {{ product.icon }}
              } @else {
                <span class="material-symbols-outlined">{{ product.icon }}</span>
              }
            </mat-icon>
            <div class="title-wrapper">
              <span>{{ product.label }}</span>
            </div>
          </div>
          <div
            class="sub-title"
            [class]="product.path.toLowerCase()">
            <span>{{ product.sub }}</span>
          </div>
        </div>
      </a>
    }
  </mat-nav-list>
</div>
